import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy py_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="section-title text-center mb_60">
                            <h2 className="fs_48 fw_700 mb_20">Privacy Policy</h2>
                            <p className="fs_18 text-color">
                                Effective Date: June 2026
                            </p>
                        </div>

                        <div className="privacy-content">

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">1. Introduction</h4>
                                <p>
                                    Welcome to <strong>Moolchandji Foods</strong>. Your privacy is
                                    important to us. This Privacy Policy explains what information
                                    we collect, how we use it, and how we protect it when you use
                                    our website or place an order with us.
                                </p>
                            </section>

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">2. Information We Collect</h4>

                                <ul>
                                    <li>Name</li>
                                    <li>Mobile Number</li>
                                    <li>Email Address (if provided)</li>
                                    <li>Delivery Address</li>
                                    <li>Location (only with your permission)</li>
                                    <li>Order History</li>
                                    <li>Customization preferences (wheat, grains, grinding type, etc.)</li>
                                </ul>
                            </section>

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">3. How We Use Your Information</h4>

                                <ul>
                                    <li>Process and deliver your orders.</li>
                                    <li>Provide customized flour based on your selections.</li>
                                    <li>Send order confirmations and delivery updates.</li>
                                    <li>Improve our products and customer experience.</li>
                                    <li>Provide customer support.</li>
                                    <li>Prevent fraud and maintain platform security.</li>
                                </ul>
                            </section>

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">4. Location Information</h4>

                                <p>
                                    We may request access to your device location to determine
                                    whether our services are available in your area and to provide
                                    accurate delivery information. Location access is optional and
                                    can be disabled from your device settings.
                                </p>
                            </section>

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">5. Payment Information</h4>

                                <p>
                                    We do not store your debit card, credit card, UPI PIN or bank
                                    account credentials on our servers. Payments are processed
                                    securely through trusted third-party payment providers.
                                </p>
                            </section>

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">6. Sharing of Information</h4>

                                <p>
                                    We do not sell or rent your personal information. Your data
                                    may only be shared with trusted service providers such as:
                                </p>

                                <ul>
                                    <li>Delivery partners</li>
                                    <li>Payment gateways</li>
                                    <li>Government authorities where legally required</li>
                                </ul>
                            </section>

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">7. Data Security</h4>

                                <p>
                                    We use reasonable technical and organizational measures to
                                    protect your personal information against unauthorized access,
                                    misuse, alteration, or disclosure.
                                </p>
                            </section>

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">8. Cookies</h4>

                                <p>
                                    Our website may use cookies to improve website performance,
                                    remember your preferences, and enhance your browsing
                                    experience. You can disable cookies through your browser
                                    settings if you prefer.
                                </p>
                            </section>

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">9. Your Rights</h4>

                                <p>You may request to:</p>

                                <ul>
                                    <li>Access your personal information.</li>
                                    <li>Update or correct your details.</li>
                                    <li>Delete your account, subject to applicable laws.</li>
                                    <li>Contact us regarding any privacy concerns.</li>
                                </ul>
                            </section>

                            <section className="mb_50">
                                <h4 className="fw_700 mb_20">10. Changes to This Policy</h4>

                                <p>
                                    We may update this Privacy Policy from time to time. Any
                                    changes will be published on this page with the updated
                                    effective date.
                                </p>
                            </section>

                            <section>
                                <h4 className="fw_700 mb_20">11. Contact Us</h4>

                                <p>
                                    If you have any questions regarding this Privacy Policy,
                                    please contact us:
                                </p>

                                <p className="mb_2">
                                    <strong>Moolchandji Foods</strong>
                                </p>

                                <p className="mb_2">
                                    📍 Near Sai Baba Chowk, Panipat, Haryana - 132103
                                </p>

                                <p className="mb_2">
                                    📞 +91 89505 00530
                                </p>

                                <p className="mb-0">
                                    📧 support@moolchandji.com
                                </p>
                            </section>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;